import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Link } from "react-router-dom";

import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";

const drawerWidth = 240;

const navItems = [
  { label: "Inicio", path: "/" },
  { label: "Catálogo", path: "/catalogo" },
  { label: "Sobre nosotros", path: "/sobre-nosotros" },
  { label: "Contactanos", path: "/contactanos" },
  { label: "Carrito", path: "/carrito" },
];

function Navbar(props) {
  const { window } = props;
  const { user, logout, loading } = useAuth();
  const { cartCount } = useCart();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorElAvatar, setAnchorElAvatar] = React.useState(null);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleAvatarMenuOpen = (event) =>
    setAnchorElAvatar(event.currentTarget);
  const handleAvatarMenuClose = () => setAnchorElAvatar(null);

  // ===============================
  // Drawer móvil
  // ===============================
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
            <Link to="/">

      <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
        <img
          src={require("../assets/img/logo.jpg")}
          alt="Logo"
          style={{ height: 40 }}
        />
      </Box>
            </Link>

      <Divider />

      <List>
        {navItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={Link}
              to={item.path}
              sx={{ textAlign: "center" }}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}


      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <AppBar
        component="nav"
        position="fixed"
        sx={{ backgroundColor: "#000" }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Botón menú mobile */}
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Logo */}
          
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link to="/">
            
            <Box
              component="img"
              src={require("../assets/img/logo.jpg")}
              alt="Logo"
              sx={{  height: { xs: 56, sm: 64, md: 80 }}}
              />
              </Link>
          </Box>

          {/* Navegación desktop */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", sm: "flex" },
              justifyContent: "center",
              gap: { sm: 0, md: 2, lg: 3 },
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item.path}
                component={Link}
                to={item.path}
                sx={{ color: "#fff" }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          {/* Derecha */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton
              color="inherit"
              component={Link}
              to="/carrito"
              sx={{ mr: user ? 1 : 0 }}
            >
              <Badge badgeContent={cartCount} color="error">
                <ShoppingCartOutlinedIcon />
              </Badge>
            </IconButton>

            {!loading && !user && (
              <>
                <Link to="/iniciar-sesión" style={{ textDecoration: "none" }}>
                  <Button sx={{ color: "#fff" }}>
                    Iniciar sesión
                  </Button>
                </Link>

                <Link to="/registrar" style={{ textDecoration: "none" }}>
                  <Button sx={{ color: "#fff" }}>
                    Registrarse
                  </Button>
                </Link>
              </>
            )}

            {user && (
              <>
                {/* Notificaciones */}
                {/* <IconButton color="inherit" onClick={handleNotiMenuOpen}>
                  <Badge badgeContent={3} color="error">
                    <NotificationsIcon />
                  </Badge>
                </IconButton>

                <Menu
                  anchorEl={anchorElNoti}
                  open={Boolean(anchorElNoti)}
                  onClose={handleNotiMenuClose}
                >
                  <MenuItem>Nueva notificación</MenuItem>
                  <MenuItem>Mensaje nuevo</MenuItem>
                </Menu> */}

                {/* Avatar */}
                 <IconButton onClick={handleAvatarMenuOpen} sx={{ ml: 2 }}>
    <Avatar
      src={user.avatar || undefined}
      sx={{
        bgcolor: user.avatar
          ? "transparent"
          : user.background_avatar || "#1976d2",
        color: "#fff",
      }}
    >
      {!user.avatar && user.name
        ? user.name.charAt(0).toUpperCase()
        : null}
    </Avatar>
  </IconButton>

                <Menu
                  anchorEl={anchorElAvatar}
                  open={Boolean(anchorElAvatar)}
                  onClose={handleAvatarMenuClose}
                >
                  <MenuItem component={Link} to="/perfil">
                    Perfil
                  </MenuItem>

                       <MenuItem component={Link} to="/mis-reservas">
                    Mis reservas
                  </MenuItem>
                  <Divider />
                  <MenuItem
                    onClick={() => {
                      logout();
                      handleAvatarMenuClose();
                    }}
                    sx={{ color: "red" }}
                  >
                    Cerrar sesión
                  </MenuItem>
                </Menu>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>

      {/* Spacer */}
      <Box component="main">
        <Toolbar />
      </Box>
    </Box>
  );
}

Navbar.propTypes = {
  window: PropTypes.func,
};

export default Navbar;
